import { render, staticRenderFns } from "./userOnline.vue?vue&type=template&id=2128c47b"
import script from "./userOnline.vue?vue&type=script&lang=js"
export * from "./userOnline.vue?vue&type=script&lang=js"
import style0 from "./userOnline.vue?vue&type=style&index=0&id=2128c47b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports